/* Spanish catalog mirroring locale-completion-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  "common.rowUnavailable": "No se pudieron cargar los datos. Int?ntalo de nuevo.",
  "common.rowContextChanged": "La empresa o el documento seleccionado ha cambiado. ?brelo de nuevo.",
  "common.bankStatementIncomplete": "El extracto bancario no se ha cargado por completo. Int?ntalo de nuevo.",
  "common.journalProofUnavailable": "No se pudieron verificar los datos contables.",

  'pay.employeesAwaitingPayment': '{{count}} empleados pendientes de pago',
  'pay.readyForPayment': 'Listo para el pago',
  'pay.readyForPaymentHelp': 'Nóminas aprobadas y contabilizadas cuyo salario aún no está registrado como pagado.',
  'pay.noRunsAwaitingPayment': 'No hay nóminas pendientes de pago',
  'pay.noRunsAwaitingPaymentHint': 'Las nóminas aprobadas aparecen aquí hasta que se registre el pago.',
  'pay.draftPayrollRuns': 'Borradores',
  'pay.noDraftPayrollRuns': 'No hay borradores de nómina.',
  'buy.ownerOutlay': 'Gasto adelantado por el propietario',
  'home.followup.assetPostingTitle': 'Amortizaciones',
  'home.followup.assetPostingAction': 'Ver la diferencia',
  'home.followup.assetPostingIssue': 'La amortización automática requiere seguimiento. Revisa el plan del activo o contacta con soporte. Plumme lo reintenta cuando se corrija la diferencia.',
  'ui.cancel': 'Cancelar',
  'ui.close': 'Cerrar',
  'ui.back': 'Atrás',
  'ui.continue': 'Continuar',
  'ui.open': 'Abrir',
  'app.close': 'Cerrar',
  'common.loadMore': 'Cargar m?s', 'common.loading': 'Cargando...',
  'shell.collapse': 'Contraer menú',
  'chat.cardFromFirm': 'Tu contable ha escrito',
  'chat.cardFromYou': 'Has escrito',
  'chat.cardNone': 'Aún no hay mensajes',
  'chat.firm': 'Tu contable',
  'chat.helpTitle': 'Tu contable',
  'chat.help': 'Escribe directamente a tu contable. Solo tú, como propietario o administrador, ves esta conversación.',
  'chat.cardOpenUnread': 'Leer mensaje',
  'chat.cardOpen': 'Enviar un mensaje',
  'chat.modalTitle': 'Tienes un mensaje sin leer',
  'chat.modalOpen': 'Abrir el chat',
  'chat.modalBody': 'te ha enviado un mensaje que no has leído.',
  'chat.client': 'El cliente',
  'chat.subFirm': 'Conversación con el cliente',
  'chat.subClient': 'Conversación con tu contable',
  'chat.emptyFirm': 'Aún no hay mensajes. Escribe al cliente aquí: lo verá en Plumme.',
  'chat.emptyClient': 'Aún no hay mensajes. Haz tus preguntas a tu contable.',
  'chat.placeholder': 'Escribe un mensaje …',
  'chat.send': 'Enviar',
  'rf.client.takeoverSaved': 'La fecha de asunción se ha guardado',
  'rf.client.takeover': 'Fecha de asunción',
  'rf.client.takeoverHelp': 'Los periodos y plazos anteriores a esta fecha no se consideran trabajo de la asesoría. Las obligaciones propias del cliente no cambian.',
  'rf.client.takeoverSave': 'Guardar fecha',
  'clo.cash.invalidAmount': 'Introduce el importe de caja contado.',
  'clo.cash.documentationRequired': 'Describe la justificación del recuento antes de aprobar.',
  'clo.cash.saved': 'El recuento de caja se ha guardado.',
  'clo.cash.saveError': 'No se pudo guardar el recuento de caja.',
  'clo.cash.title': 'Monedas y billetes',
  'clo.cash.readySubtitle': 'La caja se ha contado y coincide con la cuenta 1900.',
  'clo.cash.naSubtitle': 'No hay saldo de caja registrado en la cuenta 1900.',
  'clo.cash.todoSubtitle': 'Cuenta la caja a 31.12 y compárala con la cuenta 1900.',
  'clo.cash.noStatus': 'El estado de la caja aún no se ha calculado.',
  'clo.cash.booked': 'Contabilizado en 1900',
  'clo.cash.counted': 'Contado a 31.12',
  'clo.cash.difference': 'Diferencia',
  'clo.cash.countedField': 'Importe de caja contado',
  'clo.cash.account': 'Cuenta de caja',
  'clo.cash.documentation': 'Justificación del recuento',
  'clo.cash.documentationPlaceholder': 'Por ejemplo: caja contada el 31.12 por el director general. La hoja de recuento se archiva con los justificantes.',
  'clo.cash.noDifferenceHelp': 'Cuando el importe contado coincide con la cuenta 1900, el recuento se guarda como justificante sin asiento adicional.',
  'clo.cash.surplusHelp': 'La diferencia aumenta la cuenta 1900 y se contabiliza como otros ingresos.',
  'clo.cash.shortageHelp': 'La diferencia reduce la cuenta 1900 y se contabiliza como otros gastos.',
  'clo.cash.approve': 'Aprobar recuento',
  'clo.chart.suggestionsReady': 'Las sugerencias están listas para aprobar.',
  'clo.chart.noSuggestions': 'No se encontraron sugerencias fiables.',
  'clo.chart.pickBeforeApprove': 'Elige una cuenta estándar antes de aprobar.',
  'clo.chart.saved': '{{count}} equivalencias de cuentas guardadas',
  'clo.chart.saveError': 'No se pudieron guardar las equivalencias de cuentas.',
  'clo.chart.title': 'Plan de cuentas',
  'clo.chart.missingSubtitle': '{{count}} cuentas personalizadas no tienen equivalencia con una cuenta estándar.',
  'clo.chart.readySubtitle': 'El plan de cuentas está listo para el cierre anual.',
  'clo.chart.allMapped': 'Todas las cuentas personalizadas están asociadas a una cuenta estándar.',
  'clo.chart.instructions': 'Elige la cuenta estándar a la que equivale cada cuenta personalizada.',
  'clo.chart.aiSuggest': 'Buscar sugerencias con IA',
  'clo.chart.accountFallback': 'Cuenta {{code}}',
  'clo.chart.missingMapping': 'Falta la equivalencia estándar',
  'clo.chart.equivalent': 'Cuenta estándar equivalente',
  'clo.chart.reset': 'Restablecer sugerencias',
  'clo.chart.approve': 'Aprobar {{count}} sugerencias',
  'clo.share.title': 'Capital social',
  'clo.share.readySubtitle': 'El capital social está contabilizado en la cuenta 2000.',
  'clo.share.missingSubtitle': 'Revisa o contabiliza el capital social antes de terminar el cierre anual.',
  'clo.share.noStatus': 'El estado del capital social aún no se ha calculado.',
  'clo.share.booked': 'Contabilizado en 2000',
  'clo.share.minimum': 'Mínimo para una AS noruega',
  'clo.share.lossNote': 'Las pérdidas o el patrimonio neto perdido normalmente no deben retirarse de la cuenta 2000. Se evalúan en el patrimonio neto, la aplicación del resultado y la continuidad de la actividad. Este punto solo comprueba que el capital social registrado esté contabilizado en el haber de la cuenta 2000.',
  'clo.share.freePosting': 'Contabilizar el capital social',
  'sharedText.app.employeePortalVerifyTitle': 'Confirma tu dirección de correo electrónico',
  'sharedText.auth.remember': 'Recordarme',
  'sharedText.auth.noAccount': '¿Aún no tienes cuenta?',
  'sharedText.auth.forgotCopy': 'Introduce el correo con el que inicias sesión y te enviaremos un enlace para establecer una nueva contraseña.',
  'sharedText.acc.sentLinkTo': 'Hemos enviado un enlace a',
  'sharedText.rep.export.year': 'Año',
  'sharedText.bank.previewVoucher': 'Previsualizar el justificante',
  'sharedText.km.returnTrip': 'Viaje de vuelta',
  'sharedText.pay.paidOut': 'Pagado',
  'sharedText.inv.col.net': 'Neto',
  'sharedText.transaction.by': 'por',
  'sharedText.buy.pickCategory': 'Cuenta/categoría',
  'sharedText.vat.vat': 'IVA',
  'sharedText.sup.seeVoucher': 'Ver justificante',
  'sharedText.bwf.correctEntry': 'Corregir asiento',
  'sharedText.ap.approve': 'Aprobar',
  'sharedText.sale.pay.partialStatusRemaining': 'pendiente',
  'sharedText.helpTopics.ocrCorrection.title': 'Corregir los valores extraídos',
  'sharedText.pay.note': 'Nota',
  'sharedText.bank.openingBalance': 'Saldo de apertura',
  'sharedText.asset.closing': 'Saldo final',
  'sharedText.sale.att.dropHere': 'Suelta el adjunto aquí',
  'sharedText.voucher.pickAccount': 'Elegir cuenta',
  'sharedText.adv.scn.plan.interest': 'Intereses',
  'sharedText.sale.pay.fee': 'Comisión',
  'sharedText.ui.cancel': 'Cancelar',
  'sharedText.bwf.selectLine': 'Seleccionar movimiento bancario',
  'sharedText.bg.bankLines': 'Movimientos bancarios',
  'sharedText.home.ana.ring': 'Desglose',
  'sharedText.pj.row.new': 'Nueva fila',
  'sharedText.bank.bankLine': 'Movimiento bancario',
  'sharedText.helpTopics.openItem.title': 'Partida abierta',
  'sharedText.clo.amount': 'Importe',
  'sharedText.adv.status.more': 'Más opciones',
  'sharedText.inboxStatus.dropReceipts': 'Suelta los recibos aquí',
  'sharedText.bank.uploading': 'Subiendo …',
  'sharedText.set.showAll': 'Mostrar todo',
  'sharedText.bank.voucherReceivedOn': 'Justificante recibido el',
  'sharedText.set.acc.lines': 'líneas',
  'sharedText.nav.budget': 'Presupuesto',
  'sharedText.bud.actual': 'Real',
  'sharedText.ui.close': 'Cerrar',
  'sharedText.pay.signOut': 'Cerrar sesión',
  'sharedText.rf.group.firm': 'Contable',
  'sharedText.rf.create.title': 'Crear asesoría contable',
  'sharedText.ui.open': 'Abrir',
  'sharedText.buy.next': 'Siguiente',
  'sharedText.adv.docs.hide': 'Ocultar',
  'sharedText.fe.decline': 'Rechazar',
  'sharedText.common.yes': 'Sí',
  'sharedText.ap.review.checked': 'Revisado',
  'sharedText.clo.pick': 'Elegir',
  'sharedText.nav.taxReturn': 'Declaración de impuestos',
  'sharedText.clo.financialYear': 'El ejercicio fiscal',
  'sharedText.helpTopics.residualValue.title': 'Valor residual',
  'sharedText.clo.inventoryReview.undecided': 'Elegir valoración',
  'sharedText.helpTopics.readyForUse.title': 'Listo para su uso',
  'sharedText.asset.work.residualValue': 'Valor residual esperado',
  'sharedText.inv.credit.line': 'Línea',
  'sharedText.buy.paid': 'Pagada',
  'sharedText.km.from': 'Desde',
  'sharedText.km.to': 'Hasta',
  'sharedText.set.accountNo': 'N.º de cuenta',
  'sharedText.sale.credit.previewReason': 'Motivo:',
  'sharedText.clo.description': 'Descripción',
  'sharedText.prd.price': 'Precio',
  'sharedText.clo.sum': 'Total',
  'sharedText.inv.kpi.sub.exVat': 'Sin IVA',
  'sharedText.set.page': 'Página',
  'sharedText.sale.cust.org': 'N.º de empresa',
  'sharedText.trv.vehicle': 'Vehículo',
  'sharedText.ap.monthControl.finding.deviation': 'Posible desviación',
  'sharedText.vat.cancel': 'Cancelar',
  'sharedText.bank.review': 'Revisar',
  'sharedText.inbox.supplierInvoice': 'Factura de proveedor',
  'sharedText.bank.roundingHelp': 'Úsalo solo para una pequeña diferencia de redondeo real. El importe se contabiliza sin IVA contra',
  'sharedText.trv.reason': 'Motivo',
  'sharedText.set.acc.vatRegisteredPick': 'Elige una respuesta',
  'sharedText.set.acc.vatRegisteredUnknown': 'No estoy seguro',
  'sharedText.set.acc.vatRegisteredFrom': 'Registrada a efectos de IVA desde',
  'sharedText.vat.due': 'Fecha límite',
  'sharedText.pay.advance': 'Anticipo',
  'sharedText.pay.aga': 'Cotización del empleador',
  'sharedText.inv.col.number': 'N.º',
  'sharedText.onb.createPersonal': 'Crea tus finanzas personales',
  'sharedText.onb.createPersonalHelp': 'Esto crea un usuario de finanzas personales independiente, que encontrarás en Mi página y en el selector de usuario.',
  'sharedText.onb.noBankData': 'La conexión bancaria aún no está activa. Puedes subir extractos bancarios manualmente cuando quieras.',
  'sharedText.po.youHaveStated': 'Has indicado que',
  'sharedText.po.wealthStrongestOn': 'Tu patrimonio puntúa más alto en',
  'sharedText.po.withYourAssumptions': 'Con los supuestos que has introducido, tu patrimonio cambia aproximadamente',
  'sharedText.po.splitIsEven': 'El reparto es equitativo. Ustedes comparten',
  'sharedText.po.householdHasRegistered': 'El hogar ha registrado',
  'sharedText.po.budgetTotal': 'Total del presupuesto:',
  'sharedText.set.bank.typeTax': 'Retención de impuestos',
  'sharedText.clo.no': 'No',
  'sharedText.po.showingScenario': 'Mostrando escenario:',
  'sharedText.po.desiredNetWealth': 'Patrimonio neto deseado',
  'sharedText.po.lastsUntilYouAre': 'dura hasta que tengas',
  'sharedText.sd.transition.years': 'años',
  'sharedText.po.lasts': 'dura',
  'sharedText.po.prioritise': 'Priorizar',
  'sharedText.adv.scn.loan.monthsUnit': 'm',
  'sharedText.po.doYouWantToDelete': '¿Quieres eliminar',
  'sharedText.po.householdSpends': 'El hogar gasta',
  'sharedText.po.iRecommend': 'Recomiendo',
  'sharedText.po.debtFree': 'Sin deudas',
  'sharedText.po.interestPostedAs': 'Los intereses y las cuotas de este préstamo se contabilizan como',
  'sharedText.helpTopics.buffer.title': 'Colchón de liquidez',
  'sharedText.clo.save': 'Guardar',
  'sharedText.adv.profile.buffer': 'Colchón deseado',
  'sharedText.home.legend.income': 'Ingresos',
  'sharedText.set.bank.typeSavings': 'Ahorro',
  'sharedText.pay.category': 'Categoría',
  'sharedText.set.account': 'Cuenta',
  'sharedText.po.allAccounts': 'Todas las cuentas',
  'sharedText.adv.status.snooze7': 'Recordármelo en una semana',
  'sharedText.po.yourHealthScoreIs': 'Tu puntuación de salud financiera es',
  'sharedText.po.outOf100': 'sobre 100',
  'sharedText.po.taxAssistant': 'Asistente de declaración de impuestos',
  'sharedText.cust.prev': 'Anterior',
  'sharedText.bank.finishReview': 'Terminar la revisión',
  'sharedText.po.checkBasis': 'Base de la comprobación',
  'sharedText.clo.name': 'Nombre',
  'sharedText.set.text': 'Texto',
  'sharedText.sale.textLine.boldShort': 'N',
  'sharedText.sale.textLine.italicShort': 'K',
  'sharedText.sale.lines.useDivider': 'Usar línea divisoria',
  'sharedText.sale.textLine.dividerHint': 'Muestra una línea bajo el texto en el documento.',
  'sharedText.nav.products': 'Productos',
  'sharedText.sale.textLine.titleNewText': 'Nueva línea de texto',
  'sharedText.prd.deleted': 'Eliminado',
  'sharedText.pay.edit': 'Editar',
  'sharedText.clo.delete': 'Eliminar',
  'sharedText.set.loans.startDate': 'Fecha de inicio',
  'sharedText.helpTopics.unitCost.title': 'Coste unitario',
  'sharedText.pay.optional': 'Opcional',
  'sharedText.registry.group': 'Grupo de productos',
  'sharedText.clo.add': 'Añadir',
  'sharedText.ha.products.account': 'Cuenta de ingresos',
  'sharedText.clo.accountNumber': 'Número de cuenta',
  'sharedText.clo.accountName': 'Nombre de la cuenta',
  'sharedText.buy.supplierNew': 'Nuevo proveedor',
  'sharedText.auth.createAccount': 'Crear cuenta',
  'sharedText.set.acc.equivalent': 'Equivale a la cuenta',
  'sharedText.bwf.entry': 'Asiento',
  'sharedText.sale.att.upload': 'Subir adjunto',
  'sharedText.vat.settlement': 'Liquidación',
  'sharedText.ap.agent.invoice.selectRow': 'Seleccionar factura',
  'sharedText.ap.workspace.treatmentAsset': 'Registrar como activo fijo',
  'sharedText.bank.receiptLinked': 'Vinculado a un movimiento bancario',
  'sharedText.sd.documents.count': 'documentos',
  'sharedText.set.debit': 'Debe',
  'sharedText.set.bank.accounts': 'Cuentas bancarias',
  'sharedText.sd.deleteBusinessHelp': 'Eliminar la empresa borra la empresa seleccionada tras 30 días a través del backend. Es una acción seria.',
  'sharedText.vat.rate': 'Tipo',
  'sharedText.inv.bulk.noEmail': 'sin correo electrónico',
  'sharedText.trv.privateRefundOf': 'Reembolso personal de',
  'sharedText.asset.group': 'Grupo',
  'sharedText.asset.opening': 'Apertura',
  'sharedText.asset.movements': 'Movimientos',
  'sharedText.set.credit': 'Haber',
  'sharedText.voucher.backToVat': 'Volver a la declaración de IVA',
  'sharedText.vat.vatCode': 'Código de IVA',
  'sharedText.bank.markVoucherLostTitle': 'Marcar el justificante como perdido',
  'sharedText.bank.voucherLostReason': 'Explicación',
  'pay.salaryLineDeleted': 'Línea de salario eliminada.',
  'pay.salaryLineNotFound': 'La línea de salario ya no existe.',
  'pay.deleteSalaryLine': 'Eliminar línea de salario',
  'pay.deleteSalaryLineConfirm': '¿Eliminar “{{name}}” de este borrador de nómina?',
  'pay.accountingVouchers': 'Justificantes contables',
  'pay.payrollVoucher': 'Justificante de nómina',
  'pay.paymentVoucher': 'Justificante de pago',
  'pay.paymentVoucherInDifferentYear': 'El pago se contabilizó en {{year}} y por eso aparece en el balance de comprobación de ese año.',
  'pay.settleSalaryLiability': 'Liquidación de salarios pendientes de pago',
  'pay.settleEmployeeExpense': 'Liquidación de gasto de empleado',
  'pay.paymentFromBank': 'Pago desde cuenta bancaria',
});
